import { apiClient } from './client';
import { Relatorios } from '../types';

export function buscarRelatorios(): Promise<Relatorios> {
  return apiClient.get('/relatorios').then((res) => res.data);
}
